import { ref, isRef, Ref } from 'vue'
import { useQuery } from '@cqrs/vue-composables-cqrs'
import * as q from './queries-core'
export function useCapexAccountByIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, capexId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const _capexId = isRef<string>(capexId) ? capexId : ref<string>(capexId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		capexId: _capexId,
		...useQuery(() => new q.CapexAccountByIdQueryV1(_workspaceId.value, _strategyId.value, _capexId.value))
	}
	return {
		...result,
		runCapexAccountByIdQueryV1: result.run,
		modelCapexAccountByIdQueryV1: result.model,
	}
}

export function useCapexAccountsByPortfolioIdQueryV1(workspaceId?: number | Ref<number>, portfolioId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _portfolioId = isRef<string>(portfolioId) ? portfolioId : ref<string>(portfolioId)
	const result = {
		workspaceId: _workspaceId,
		portfolioId: _portfolioId,
		...useQuery(() => new q.CapexAccountsByPortfolioIdQueryV1(_workspaceId.value, _portfolioId.value))
	}
	return {
		...result,
		runCapexAccountsByPortfolioIdQueryV1: result.run,
		modelCapexAccountsByPortfolioIdQueryV1: result.model,
	}
}

export function useCapexAccountsByStrategyIdQueryV1(workspaceId?: number | Ref<number>, strategyId?: string | Ref<string>, ) {
	const _workspaceId = isRef<number>(workspaceId) ? workspaceId : ref<number>(workspaceId)
	const _strategyId = isRef<string>(strategyId) ? strategyId : ref<string>(strategyId)
	const result = {
		workspaceId: _workspaceId,
		strategyId: _strategyId,
		...useQuery(() => new q.CapexAccountsByStrategyIdQueryV1(_workspaceId.value, _strategyId.value))
	}
	return {
		...result,
		runCapexAccountsByStrategyIdQueryV1: result.run,
		modelCapexAccountsByStrategyIdQueryV1: result.model,
	}
}

